export default class{

    constructor(){
        this.appLoad = new CustomEvent('app-load');
        this.appScroll = new CustomEvent('app-scroll');
        this.appResize = new CustomEvent('app-resize');
        this.appObserve = new CustomEvent('app-observe');
        this.appBlur = new CustomEvent('app-blur');
        this.appFocus = new CustomEvent('app-focus');
        this.smoothScroll = new CustomEvent('smooth-scroll');
        this.endOpening = new CustomEvent('end-opening');
        this.togglePanel = new CustomEvent('toggle-panel');

        document.dispatchEvent(this.appObserve);

        window.onload = (event) => {
            document.dispatchEvent(this.appLoad);
            document.dispatchEvent(this.appObserve);
        };
        window.onscroll = (event) => {
            document.dispatchEvent(this.appScroll);
            document.dispatchEvent(this.appObserve);
        };
        window.onresize = (event) => {
            document.dispatchEvent(this.appResize);
            document.dispatchEvent(this.appObserve);
        };
        window.onblur = (event) => {
            document.dispatchEvent(this.appBlur);
        };
        window.onfocus = (event) => {
            document.dispatchEvent(this.appFocus);
        };
    }

}